function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d06716",
  fillRule: "nonzero",
  d: "M14.53 4.65c3.28 0 5.51 2.25 5.51 5.29 0 .92-.3 1.78-.99 2.53-.48.48-1.02 1.02-2.2 1.88 2.1 1.29 4 2.9 4 5.9 0 4.34-3.79 6.49-6.71 6.49-3.94 0-6.53-2.29-6.53-5.77 0-1.61.73-2.43 1.26-3.01.54-.55 1.9-1.5 2.8-2.08-1.74-1.09-3.31-2.76-3.31-5.29 0-3.24 2.52-5.94 6.14-5.94h.03zm-.09 20.72c1.68 0 2.8-1.47 2.77-3.72-.06-2.46-1.5-3.35-4.42-5.12-.88.75-1.57 2.25-1.57 4.02 0 3.32 1.75 4.82 3.19 4.82h.03zm-.38-19.35c-1.42 0-2.23 1.57-2.23 3.01 0 2.32 1.56 3.45 3.88 4.68.51-.55 1.11-1.61 1.11-3.59 0-2.94-1.53-4.1-2.73-4.1h-.03z"
});

var Svg8 = function Svg8(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg8, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/8.d2f6049d.svg";
export { ForwardRef as ReactComponent };